import { FC, useCallback, useContext, useEffect, useMemo, useState } from "react";
import styles from "./styles.module.scss";
import { Breadcrumb, Notification } from "@douyinfe/semi-ui";
import Link from "next/link";
import { useRouter } from "next/router";
import { EnNavType } from "../navbar";
import cName from "classnames";
import { IconChevronRight } from '@douyinfe/semi-icons';
import axios from 'axios';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css'
import 'swiper/css/pagination'
import 'swiper/css/navigation';
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import { IndexContext } from "@/stores";


type CrumbType = {
  path: string,
  name: string,
}

export interface IEnLayoutProps {
  crumb?: CrumbType[],
  backgroundColor?: string;
  banner?: string;
  newsPath?: string | undefined | null;
}


export const EnPageLayout: FC<IEnLayoutProps & { children: JSX.Element }> = ({
  children,
  crumb = [],
  backgroundColor = 'white',
  banner = '/image/about-banner.png',
  newsPath
}) => {
  const { nav } = useContext(IndexContext)
  const [menu, setMenu] = useState<EnNavType>()
  const [active, setActive] = useState<EnNavType>()
  const router = useRouter()
  const [visible, setVisible] = useState(false)
  const [isSearch, setIsSearch] = useState(false)

  const navTo = useCallback((e: any, item: EnNavType): void => {
    if (router.asPath == item.path) {
      return
    }
    e.stopPropagation();
    // if (item.path === '/audience/register') {
    //   setVisible(true)
    //   return
    // }
    if (item.outlink) {
      const a = document.createElement("a")
      a.href = `${item.outlink}`
      a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      return
    }
    router.push(item.path as any, item.path as any, {
      shallow: true
    })
  }, [active, nav])


  const searchNode = (data: any, path: string) => {
    for (let i = 0; i < data?.length; i++) {
      const item = data[i];
      if (item.path === path) {
        return item;
      }

      if (item.children && Array.isArray(item.children)) {
        const found = searchNode(item.children, path) as any;
        if (found) {
          return found;
        }
      }
    }

    return null;
  };

  // useEffect(() => {
  //   const { text } = router.query;
  //   setIsSearch(!!text)
  // }, [router.query])

  useEffect(() => {
    const act = searchNode(nav, newsPath || router.asPath)
    setActive(act)
    const item = nav?.find(item => item.id === act?.parent)
    setMenu(item)
  }, [nav])


  return (
    <div className={styles.page} style={{ backgroundColor }}>
      <div className={styles.pageBg}>
        <img src={banner} alt="" />
        <div className={styles.pageHeader}>
          <p>Sustainable Lifestyle in Organics</p>
          <h1>{menu?.name || active?.name}</h1>
          {
            !isSearch
            && menu?.children
            && menu.children.length > 1
            && (
              menu.children.length == 1 ? <h1>{menu?.children[0].name}</h1> : (
                <ul className={cName([styles.pageNav])}>
                  {
                    menu?.children?.map(item => (

                      <li key={item.id} style={{
                        zIndex: '100',
                        background: item.id === active?.id ?
                          '#93d40b'
                          : '',
                      }} onClick={(e) => navTo(e, item)}><span>{item.name}</span></li>
                    ))
                  }
                </ul>
              )
            )
          }
          <Swiper
            className={styles.swiper}
            modules={[]}
            spaceBetween={15}
            slidesPerView="auto"
            style={{ display: 'none' }}
          >

            {
              !isSearch
              && menu?.children
              && menu.children.length > 1
              && (
                menu.children.length == 1 ? <h1>{menu?.children[0].name}</h1> : (
                  <div>
                    {
                      menu?.children?.map(item => (
                        <SwiperSlide key={item.id}>
                          <div
                            className={styles.swiperList}
                            style={{
                              zIndex: '100',
                              background: item.id === active?.id ?
                                '#93d40b'
                                : '',
                            }} onClick={(e) => navTo(e, item)}>{item.name}</div>
                        </SwiperSlide>
                      ))
                    }
                  </div>
                )
              )
            }

            <SwiperSlide></SwiperSlide>
          </Swiper>
        </div>
      </div>
      <div className={styles.crumb}>
        <img src="/image/crumb-icon.png" alt="" />
        <Breadcrumb
          compact={false}
          routes={
            [
              {
                path: '/',
                name: 'Home'
              },
              {
                path: active?.path || menu?.path || '',
                name: menu?.name || '',
                isShow: !menu
              },
              {
                path: active?.path || '',
                name: active?.name || '',
                isShow: !active
              },
              ...crumb
            ].filter((item: any) => !item.isShow) as any
          }
          onClick={(item) => {
            router.push(item.path as any, item.path as any, {
              shallow: true
            })
          }
          }
          separator={'>'} />
      </div>
      <div className={cName([styles.content, 'content'])}>
        <div>
          <div style={{ width: '100%' }}>
            {children}
          </div>
        </div>
        {/* <MyModal visible={visible} onOk={() => setVisible(false)}></MyModal> */}
      </div>
      <style jsx global>
        {
          `
            .semi-navigation{
              border:none !important;
              padding:0 !important;
            }
            .semi-navigation-header-text{
              width:100%;
            }
            .semi-navigation-header{
              padding:0 !important;
              margin-top:40px;
            }
            .semi-navigation-item{
              height:auto !important;
              padding: 0 12px !important;
            }
            .semi-navigation-item-text{
              display:block;
              width:100%;
            }
            .semi-navigation-footer{
              position: absolute;
              top: 0;
              left: 20%;
            }
            .semi-navigation-list-wrapper{
              height: auto !important;
              padding:0 !important;
              margin:10px 0;
            }
            .semi-breadcrumb-item-active{
              color: #094020 !important; 
            }
            .semi-navigation-collapsed{
              height:70px !important;
            }
            .semi-breadcrumb-item-link:hover{
              color: #808080;
            }
            .semi-notification-notice{
              min-width: '200px'
            }
            .swiper-wrapper,
            .swiper-slide{
              width:auto;
            }
            .semi-breadcrumb-item-wrap{
              margin: 4px 6px;
            }
          `
        }
      </style>
    </div>
  );
};
